import { useEffect } from "react";
import "@css/LoginPage.css"; // Путь к файлу с CSS
import { toast } from "react-toastify";

// URL для входа через Lichess с учетом redirect параметра
const buildLoginUrl = (search) => {
    const redirectPath = new URLSearchParams(search).get("redirect");
    // The current origin, so the dev server works on any port
    const baseUrl = window.location.origin;
    const redirectUrl = redirectPath ? `${baseUrl}${redirectPath}` : `${baseUrl}/`;
    return `${import.meta.env.VITE_API_URL}/auth/lichess?redirect=${encodeURIComponent(redirectUrl)}`;
};

const LoginPage = () => {
    const loginUrl = buildLoginUrl(window.location.search);

    useEffect(() => {
        document.title = "Войти";

        const failMessage = new URLSearchParams(window.location.search).get("fail");
        if (failMessage) {
            toast.error(`Ошибка входа: ${failMessage}`);
        }
    }, []);

    return (
        <div className="login-page">
            <h1>Шахматный клуб Imatran shakki</h1>
            <p>Обучение, призы за победы в турнирах и участие в челленджах!</p>
            {loginUrl ? <a href={loginUrl}>
                <button className="login-btn">
                    Войти через Lichess{" "}
                    <img
                        style={{ width: "20px", height: "20px" }}
                        src="/images/lichess.svg"
                        alt="Lichess Logo"
                        className="lichess-logo"
                    />
                </button>
            </a> : null}
        </div>
    );
};

export default LoginPage;
